function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M334.3 305.5c-8.2 71.9-67 144.2-161.4 144.5C90.1 450.3 4 379.1 3.6 264.7c-.2-75.6 40.2-148.4 92-191.6C146 31 215.2 4 277.9 3.8c6.7 0 13.6.4 18.7 1.6h.1c1.2.3 1.5 1.1.1 1.4h-.1c-53.5 12.6-95.6 63.3-95.4 120.6 0 1.9.2 4 .4 4.9 29.7 7.3 54.2 18.1 73.7 32",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none",
  fillRule: "evenodd"
});

var SvgBrandOutlineReversed = function SvgBrandOutlineReversed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 339 454",
    "aria-hidden": true
  }, props), _ref);
};

export default SvgBrandOutlineReversed;